import { render, staticRenderFns } from "./archives-printscreen.vue?vue&type=template&id=7e93fbea&scoped=true"
import script from "./archives-printscreen.vue?vue&type=script&lang=js"
export * from "./archives-printscreen.vue?vue&type=script&lang=js"
import style0 from "./archives-printscreen.vue?vue&type=style&index=0&id=7e93fbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e93fbea",
  null
  
)

export default component.exports